/**
 * HealthSummary: fleet totals per health level and activity, as text.
 */
import type { HealthSummary as Summary } from '../models/siteMapModels';
import { formatActivityWindow } from '../utils/siteMapPresentation';
import { SiteMapStatusPill } from './SiteMapStatusPill';

interface HealthSummaryProps {
  readonly summary: Summary;
  readonly recentShotsWindowS: number;
}

export function HealthSummary({ summary, recentShotsWindowS }: HealthSummaryProps): JSX.Element {
  return (
    <section className="site-map-panel__section" aria-labelledby="site-map-summary-heading">
      <h2 id="site-map-summary-heading" className="site-map-panel__heading">
        Fleet health
      </h2>
      <p className="site-map-summary__total">
        {summary.total} site{summary.total === 1 ? '' : 's'} on the map
      </p>
      <ul className="site-map-summary__levels">
        <li>
          <SiteMapStatusPill tone="ok" label={`${summary.ok} OK`} />
        </li>
        <li>
          <SiteMapStatusPill tone="warning" label={`${summary.suspect} Suspect`} />
        </li>
        <li>
          <SiteMapStatusPill tone="neutral" label={`${summary.unknown} Unknown`} />
        </li>
        {summary.noData > 0 && (
          <li>
            <SiteMapStatusPill tone="neutral" label={`${summary.noData} No health data`} />
          </li>
        )}
      </ul>
      <p className="site-map-summary__active">
        <span className="site-map-summary__active-dot" aria-hidden="true" />
        {summary.active} active in the last {formatActivityWindow(recentShotsWindowS)}
      </p>
    </section>
  );
}
